import ReactOnRails from 'react-on-rails';

// Components.

// Demo component for testing things.
//import HelloWorld from '../HelloWorld/HelloWorld';

// -- all pages
import VehicleChooserApp from "../VehicleChooser/container/VehicleChooserApp";
import ShowCustomerVehicleApp from "../ShowCustomerVehicle/ShowCustomerVehicleApp";
import VehicleYearChooserApp from "../VehicleYearChooser/VehicleYearChooserApp";
import EyeInTheSkyApp from "../EyeInTheSky/EyeInTheSkyApp";

// cart/checkout
import ShoppingCartApp from '../ShoppingCart/container/ShoppingCartApp';
import SaveCartApp from '../SaveCart/container/SaveCartApp';
import CheckoutApp from '../Checkout/container/CheckoutApp';

//
// These components can be used in an app or can exist at top level.
//
import TextToClipboard from "../Common/components/TextToClipboard";  // can be top-level
import RevealContentButton from "../Common/components/RevealContentButton";
import ScrollToProductsButton from "../VehicleChooser/components/ScrollToProductsButton";
import DynamicCartApp from "../DynamicCart/container/DynamicCartApp";  // top-level
import CartIconApp from "../CartIcon/CartIconApp";  // top-level
import CompareItemsApp from "../CompareItems/CompareItemsApp";
import SubscribeCheckbox from "../Common/components/SubscribeCheckbox";
import ReportOrderCompleteApp from "../OrderComplete/ReportOrderCompleteApp";
import PropsDumper from "../Utility/Dumper/PropsDumper";
import CarouselApp from "../Carousel/CarouselApp";
import PhoneHoursApp from "../PhoneHours/PhoneHoursApp";
import RequestReceiptApp from "../OrderReceipts/RequestReceiptApp";
import GroupPageApp from "../ProductGroupPage/containers/GroupPageApp";
import ZoidbergApp from "../Zoidberg/container/ZoidbergApp";
import KlaviyoUnsubscribeApp from "../Klaviyo/KlaviyoUnsubscribeApp";
import SubscribeForm from "../SubscribeForm/SubscribeForm";

import ExploreStrangeNewWorldsApp from "../Demo/ExploreStrangeNewWorldsApp";
import DemoComponent from "../Utility/Dumper/DemoComponent";
import MenuBarApp from "../MenuBar/MenuBarApp";
import DropdownMenuApp from "../MenuBar/DropdownMenuApp";

import HamburgerMenuApp from "../HamburgerMenu/HamburgerMenuApp";
import HamburgerButtonApp from "../HamburgerMenu/HamburgerButtonApp";
import RevealSearchFormApp from "../Search/RevealSearchFormApp";
import Prop65Warning from "../Common/components/Prop65Warning";
import WarrantyBadge from "../Common/components/WarrantyBadge";
import ProductImagesApp from "../ProductImages/container/ProductImagesApp";
import FaqList from "../Tubes/FaqList";

ReactOnRails.register({
  // redux-using apps
  CartIconApp,
  CheckoutApp,
  CompareItemsApp,
  DemoComponent,      // Print children and properties
  DynamicCartApp,
  EyeInTheSkyApp,
  FaqList,
  KlaviyoUnsubscribeApp,
  MenuBarApp,                // 2024 NOL pulldown menu redesign
  DropdownMenuApp,            // 2024 NOL pulldown menu redesign
  HamburgerButtonApp,       // 2024 NOL Hamburger Menu
  HamburgerMenuApp,       // 2024 NOL Hamburger Menu
  Prop65Warning,          // 2025 used on Carlyle Group Pages
  ProductImagesApp,       // 2025-06 new image gallery for prod & group pages
  ReportOrderCompleteApp,
  RevealContentButton,
  SaveCartApp,
  ShoppingCartApp,
  ShowCustomerVehicleApp,
  SubscribeCheckbox,      // 2023-02 a standalone "subscribe" checkbox. used in new_checkout/completions
  SubscribeForm,          // 2024-09 a Klaviyo subscribe form with an email field
  VehicleChooserApp,
  VehicleYearChooserApp,
  PropsDumper,
  RequestReceiptApp,
  RevealSearchFormApp, // carlyle search button
  GroupPageApp,
  // containerless widgets
  ScrollToProductsButton,
  TextToClipboard,
  CarouselApp,
  PhoneHoursApp,
  ZoidbergApp,
  WarrantyBadge,
  ExploreStrangeNewWorldsApp // demo playground
});
